import MdaeRadioGroup from "./component";
import { IRadioGroupOptions } from "devextreme-react/radio-group";
import { IMdaeDataUpdaterConfig } from "../../mdae-framework";
export interface IMdaeRadioGroup extends IRadioGroupOptions {
  id: string;
  mdaeDataUpdaterConfig?: Array<IMdaeDataUpdaterConfig>;
}
export default MdaeRadioGroup;
